import { render, staticRenderFns } from "./ReCardClient.vue?vue&type=template&id=300582c1&scoped=true"
import script from "./ReCardClient.vue?vue&type=script&lang=js"
export * from "./ReCardClient.vue?vue&type=script&lang=js"
import style0 from "./ReCardClient.vue?vue&type=style&index=0&id=300582c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300582c1",
  null
  
)

export default component.exports